import OperationsReport from './OperationsReport';
export default function OperationalKPIs(){return <OperationsReport kind="kpis"/>;}
